<template>
    <div>
        <div style="width: 90%">
            <b-card bg-variant="light">
                <b-row>
                    <b-col cols="4"></b-col>
                    <b-col cols="8"><span style="font-size: 20px; font-weight: bold"> Be sure to check your spam folder for your activation email.</span>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="4"><span style="font-size: 20px; font-weight: bold"> Forgot your password?</span>
                    </b-col>
                </b-row>
                <b-form-group label-cols="4" label-cols-lg="2" label-size="md" label="Email Address"
                              label-for="input-sm">

                    <b-form-input id="text-email" aria-describedby="password-help-block"
                                  v-model="email"></b-form-input>

                </b-form-group>
                <div class="button-holder">
                    <b-button class="submit-button" type="submit" @click="updatePassword" v-bind:disabled=isNotClickable
                              variant="primary">Recover
                    </b-button>

                    <b-button class="cancel-button" type="cancel" @click="cancel" variant="primary">Cancel</b-button>
                </div>
            </b-card>
            <b-modal id="modal-1" title="Password Update Request" effect="fade/zoom" hide-footer>
                <div>
                    <p class="my-4">{{ updateMessage }}</p>
                    <div slot="modal-footer" class="modal-footer">
                    </div>
                    <b-button type="button" class="btn btn-default mt-3" @click="dismissTheModal">Continue</b-button>
                </div>
            </b-modal>
        </div>
    </div>

</template>

<script>
import VueInputUi from 'vue-input-ui'

export default {
  name: "Login.vue",
  components: {
    VueInputUi
  },
  data() {
    return {
      darkMode: false,
      email: '',
      passwordUpdateStatus: false,
      isNotClickable: false,
                updateMessage: ''
            }
        },
        methods: {
            updatePassword: function () {
                this.isNotClickable = false;
                if (this.email !== "") {
                    this.$http.post("account/password/reset", {
                            email: this.email
                        },
                        {
                            headers: {
                                'content-type': 'application/json'
                            },
                        }).then(result => {
                        if (result.status === 202) {
                            let updateResult = result.data;
                            console.log(updateResult);
                            if (updateResult.result === 'SUCCESSFUL') {
                                this.passwordUpdateStatus = true;
                                this.updateMessage = "Password Reset Request Submitted. Please check your email for your password reset link.";
                            } else {
                                this.passwordUpdateStatus = false;
                                this.updateMessage = "Password Reset Request Failed";
                            }
                            this.$bvModal.show("modal-1");
                        }
                    }).catch(error => {
                        console.log("Something went wrong" + error);
                        this.updateMessage = "Password Reset Request Failed";
                        this.$bvModal.show("modal-1");
                    });
                } else {
                    console.log("An email must be present");
                    this.updateMessage = "An email must be present";
                    this.$bvModal.show("modal-1");
                }
                this.isNotClickable = true;
            },
            cancel: function () {
                this.$router.push("/login");
            },
            dismissTheModal: function () {
                this.newPassword = '';
                this.newPasswordConfirm = '';
                this.$bvModal.hide("modal-1");
                if (this.passwordUpdateStatus === true) {
                    this.$router.push("/login");
                }

            }
        }
    }
</script>

<style scoped>
    .cancel-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .submit-button {
        margin-left: 10px;
        margin-top: 5px;
    }

    .button-holder {
        horiz-align: center;
        display: flex; /*Requires vendor prefixes*/
        justify-content: center; /*Requires vendor prefixes*/
        align-items: center; /*Requires vendor prefixes*/
    }
</style>
